import dev from './dev';

export default {
  API_HOST: process.env.REACT_APP_API_HOST || dev.API_HOST,
  FEEDBACK_URL: dev.FEEDBACK_URL,
};



// WEBPACK FOOTER //
// ./src/config/index.ts